export default "__VITE_ASSET__DcnZ2o7P__"